import React from "react";
import { FormattedMessage } from "react-intl";
import Maths from "../../../util/Maths";
import ProductsParserUtil from "../../../util/ProductsParserUtil";
import InputNumber from "../../sub/fields/input/InputNumber";
import PopoverHelper from "../../sub/bootstrap/PopoverHelper";
import PriceUtil from "../../../util/PriceUtil";
class OrderProductRowAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: false,
      unavailable: 0,
      available: this.props.product.quantity,
    };
  }

  changeQuantityAvailable(value) {
    if (value > this.props.product.quantity || value < 0 || value === "")
      return;

    this.setState(
      {
        available: value,
        unavailable: this.props.product.quantity - value,
      },
      this.props.onClickCallback,
    );
  }

  changeQuantityUnavailable(value) {
    if (value > this.props.product.quantity || value < 0 || value === "")
      return;

    this.setState(
      {
        unavailable: value,
        available: this.props.product.quantity - value,
      },
      this.props.onClickCallback,
    );
  }

  render() {
    return (
      <tr
        key={this.props.keyRow}
        id={"product-" + this.props.product.id_product}
        className={this.props.product.urgent ? "text-danger" : ""}
      >
        <td className="align-middle">{this.props.product.ref}</td>
        <td className="align-middle">
          {ProductsParserUtil.swapDesignationDelimiter(
            this.props.product.designation,
          ) + " "}
          {this.props.urgent && (
            <PopoverHelper variant="danger" icon="bell">
              <FormattedMessage id="Urgent" />
            </PopoverHelper>
          )}
        </td>
        <td className="align-middle">{this.props.product.quantity}</td>
        <td className="align-middle">
          {Maths.round(this.props.product.prix_u_ht_emera)}
        </td>
        <td className="align-middle">
          {PriceUtil.formatEuro(Maths.round(this.props.product.total_ht))}
        </td>
        <td className="text-center card-body">
          <InputNumber
            id={"unavailable-" + this.props.product.id_product}
            min={0}
            max={this.props.product.quantity}
            defaultValue={this.state.unavailable}
            onChange={(e) => this.changeQuantityUnavailable(e)}
            className="unavailable-product"
          />
        </td>
        <td className="text-center card-body">
          <InputNumber
            id={"available-" + this.props.product.id_product}
            min={0}
            max={this.props.product.quantity}
            defaultValue={this.state.available}
            onChange={(e) => this.changeQuantityAvailable(e)}
            className="available-product"
          />
        </td>
      </tr>
    );
  }
}

export default OrderProductRowAdmin;
